import { useEffect } from "react";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { SplitText } from "gsap/SplitText";

import radiantBg from "../../../assets/radiance-bg-img.svg";
import brilianceBg from "../../../assets/briliance-bg-img.svg";
import possibilityBg from "../../../assets/possibillity-bg-img.svg";

gsap.registerPlugin(ScrollTrigger, SplitText);

export default function AboutSecondSection() {
  useEffect(() => {
    const initTextAnimations = async () => {
      await document.fonts.ready;

      setTimeout(() => {
        const paragraphs = document.querySelectorAll(".anim-text");

        paragraphs.forEach((p) => {
          if (getComputedStyle(p).display === "none") return;

          const split = new SplitText(p, {
            type: "lines",
            linesClass: "split-line",
          });

          gsap.from(split.lines, {
            scrollTrigger: {
              trigger: p,
              start: "top 85%",
              once: true,
            },
            y: 40,
            opacity: 0,
            duration: 1,
            ease: "power3.out",
            stagger: 0.1,
          });
        });
      }, 50); // give layout a tiny buffer to settle
    };

    initTextAnimations();

    const triggerAbout = document.querySelector(".about_second_section");

    const aboutTl = gsap.timeline({
      scrollTrigger: {
        trigger: triggerAbout,
        start: "top top",
        end: "bottom bottom",
        scrub: 0.1,
      },
    });

    aboutTl
      .to([".radiand-text", ".radiant-bg"], {
        opacity: 0,
        duration: 1,
      })
      .to([".brilliance-text", ".brilliance-bg"], {
        opacity: 1,
        duration: 1,
      })
      .to([".brilliance-text", ".brilliance-bg"], {
        opacity: 0,
        duration: 1,
      })
      .to([".possibility-text", ".possibility-bg"], {
        opacity: 1,
        duration: 1,
      });
  }, []);

  return (
    <section className="about_second_section">
      <div className="about-section-all-wrapper-parent">
        <div className="about-second-text">
          <p className="anim-text radiand-text">
            This radiant force, the very essence of life, may seem to have a
            simple task: banishing darkness and nurturing our world.
          </p>
          <p className="anim-text brilliance-text">
            Yet, its quiet brilliance transforms our existence into a playground
            of curious minds, inspiring us to explore with purpose and passion
            while revealing an essence that is true and clear.
          </p>
          <p className="anim-text possibility-text">
            That’s how we see branding. Not a gimmick. Not an accessory. But a
            force - clear, direct, and impossible to ignore. <br /> Your brand
            should do the same.
          </p>
        </div>
        <div className="about-second-bg">
          <img src={radiantBg} alt="radiant" className="radiant-bg" />
          <img src={brilianceBg} alt="brilliance" className="brilliance-bg" />
          <img
            src={possibilityBg}
            alt="possibility"
            className="possibility-bg"
          />
        </div>
      </div>
    </section>
  );
}
